var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"product-grid"},_vm._l((_vm.products),function(item,index){return _c('div',{key:'product' + index,staticClass:"product"},[_c('product-box',{attrs:{"useH2":false,"networkId":_vm.networkId,"type":_vm.constants.ITEM_BOX_TYPE.GENERAL,"product":item,"trackingReferrer":"reletedBlog"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }